(function () {
  'use strict';

  var CACHE_PREFIX = 'dd_vl_';
  var CACHE_TTL = 300000; // 5 minutes
  var SF_TOKEN = '5b053b572b0031f80b6d0465d5be4a18';
  var API_VERSION = '2026-01';

  window.ddVariantLoader = {
    fetch: function (productHandle) {
      var cacheKey = CACHE_PREFIX + productHandle;
      var cached = this.getCache(cacheKey);
      if (cached) return Promise.resolve(cached);

      var allVariants = [];
      var self = this;

      function sfFetch(query, variables) {
        return fetch('/api/' + API_VERSION + '/graphql.json', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': SF_TOKEN
          },
          body: JSON.stringify({ query: query, variables: variables })
        })
          .then(function (r) {
            if (!r.ok) throw new Error('GraphQL fetch failed (' + r.status + ')');
            return r.json();
          });
      }

      var query = [
        'query VariantsPage($handle: String!, $first: Int!, $after: String) {',
        '  product(handle: $handle) {',
        '    variants(first: $first, after: $after) {',
        '      pageInfo { hasNextPage endCursor }',
        '      nodes {',
        '        id',
        '        availableForSale',
        '        selectedOptions { name value }',
        '        price { amount }',
        '        compareAtPrice { amount }',
        '        quantityAvailable',
        '        image { url }',
        '      }',
        '    }',
        '  }',
        '}'
      ].join('\n');

      function fetchPage(cursor) {
        return sfFetch(query, {
          handle: productHandle,
          first: 250,
          after: cursor || null
        })
          .then(function (data) {
            var product = data && data.data && data.data.product;
            if (!product) return allVariants;

            var nodes = product.variants && product.variants.nodes || [];
            var pageInfo = product.variants && product.variants.pageInfo;

            var pageVariants = nodes.map(function (n) {
              var gid = String(n.id);
              var numericId = gid.indexOf('/') !== -1 ? gid.split('/').pop() : gid;
              var opts = {};
              (n.selectedOptions || []).forEach(function (o, i) {
                opts['option' + (i + 1)] = o.value;
              });
              return {
                id: parseInt(numericId, 10),
                available: n.availableForSale,
                price: Math.round(parseFloat(n.price.amount) * 100),
                compare_at_price: n.compareAtPrice ? Math.round(parseFloat(n.compareAtPrice.amount) * 100) : null,
                option1: opts.option1 || null,
                option2: opts.option2 || null,
                option3: opts.option3 || null,
                inventory_policy: n.availableForSale ? 'continue' : 'deny',
                image_url: n.image && n.image.url || null
              };
            });

            allVariants = allVariants.concat(pageVariants);

            if (pageInfo && pageInfo.hasNextPage && pageInfo.endCursor) {
              return fetchPage(pageInfo.endCursor);
            }
            self.setCache(cacheKey, allVariants);
            return allVariants;
          });
      }

      return fetchPage(null).then(function (res) {
        return res;
      }).catch(function (err) {
        console.warn('[dd-variant-loader]', err.message);
        return [];
      });
    },

    getCache: function (key) {
      try {
        var raw = sessionStorage.getItem(key);
        if (!raw) return null;
        var parsed = JSON.parse(raw);
        if (Date.now() - parsed.ts > CACHE_TTL) {
          sessionStorage.removeItem(key);
          return null;
        }
        return parsed.data;
      } catch (e) { return null; }
    },

    setCache: function (key, data) {
      try {
        sessionStorage.setItem(key, JSON.stringify({ ts: Date.now(), data: data }));
      } catch (e) { /* quota exceeded */ }
    }
  };
})();
